export default "__VITE_ASSET__B4g9TQj1__"